import axios from '@/axios'

export default {
  waitingListForEvent(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event-entries/waitinglist/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  moveToRoster(entry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/event-entries/movewaitinglistentry/${entry._id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  deleteEntry(entry) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/event-entries/waitinglist/${entry._id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
